import { Route } from "react-router-dom";
import RequireAuth from "../auth/RequireAuth";
import RequireAdmin from "../auth/RequireAdmin";
import BackofficeLayout from "./layout/BackofficeLayout";
import DashboardPage from "./pages/DashboardPage";
import ParcoursListPage from "./pages/parcours/ParcoursListPage";
import ParcoursCreatePage from "./pages/parcours/ParcoursCreatePage";
import ParcoursDetailLayout from "./pages/parcours/ParcoursDetailLayout";
import ParcoursInfoTab from "./pages/parcours/tabs/ParcoursInfoTab";
import ParcoursArtistsTab from "./pages/parcours/tabs/ParcoursArtistsTab";
import ParcoursLieuxTab from "./pages/parcours/tabs/ParcoursLieuxTab";
import ParcoursProgrammesTab from "./pages/parcours/tabs/ParcoursProgrammesTab";
import ParcoursMembersTab from "./pages/parcours/tabs/ParcoursMembersTab";
// import ParcoursStatsTab from "./pages/parcours/tabs/ParcoursStatsTab";
import ProgrammeCreateInParcours from "./pages/parcours/tabs/ProgrammeCreateInParcours";
import ProgrammeEditInParcours from "./pages/parcours/tabs/ProgrammeEditInParcours";
import MemberListPage from "./pages/members/MemberListPage";
import MemberInvitePage from "./pages/members/MemberInvitePage";
import MemberAssignmentsPage from "./pages/members/MemberAssignmentsPage";
import HarvestPage from "./pages/harvest/HarvestPage";
import PublicationRequestsPage from "./pages/publication-requests/PublicationRequestsPage";
import ArtistListPage from "./pages/artists/ArtistListPage";
import ArtistCreatePage from "./pages/artists/ArtistCreatePage";
import ArtistEditPage from "./pages/artists/ArtistEditPage";
import LieuListPage from "./pages/lieux/LieuListPage";
import LieuCreatePage from "./pages/lieux/LieuCreatePage";
import LieuEditPage from "./pages/lieux/LieuEditPage";

export const backofficeRoutes = (
  <Route
    path="/admin"
    element={
      <RequireAuth>
        <BackofficeLayout />
      </RequireAuth>
    }
  >
    <Route index element={<DashboardPage />} />

    <Route path="parcours" element={<ParcoursListPage />} />
    {/* Any authenticated member can create; editors get free-only + auto-assignment on the backend. */}
    <Route path="parcours/new" element={<ParcoursCreatePage />} />

    {/* Parcours detail (with tabs) — nested children render inside ParcoursDetailLayout */}
    <Route path="parcours/:id" element={<ParcoursDetailLayout />}>
      <Route index element={<ParcoursInfoTab />} />
      <Route path="artists" element={<ParcoursArtistsTab />} />
      <Route path="lieux" element={<ParcoursLieuxTab />} />
      <Route path="programmes" element={<ParcoursProgrammesTab />} />
      <Route path="members" element={<RequireAdmin><ParcoursMembersTab /></RequireAdmin>} />
      {/* <Route path="stats" element={<ParcoursStatsTab />} /> */}
    </Route>

    {/* Programme create/edit are full-page (not tabs) but scoped to a parcours */}
    <Route path="parcours/:id/programmes/new" element={<ProgrammeCreateInParcours />} />
    <Route path="parcours/:id/programmes/:programmeId" element={<ProgrammeEditInParcours />} />

    <Route path="lieux" element={<LieuListPage />} />
    <Route path="lieux/new" element={<LieuCreatePage />} />
    <Route path="lieux/:id" element={<LieuEditPage />} />

    <Route path="artists" element={<ArtistListPage />} />
    <Route path="artists/new" element={<ArtistCreatePage />} />
    <Route path="artists/:id" element={<ArtistEditPage />} />

    <Route path="members" element={<RequireAdmin><MemberListPage /></RequireAdmin>} />
    <Route path="members/invite" element={<RequireAdmin><MemberInvitePage /></RequireAdmin>} />
    <Route path="members/:id/assign" element={<RequireAdmin><MemberAssignmentsPage /></RequireAdmin>} />
    <Route path="harvest" element={<RequireAdmin><HarvestPage /></RequireAdmin>} />
    <Route path="publication-requests" element={<RequireAdmin><PublicationRequestsPage /></RequireAdmin>} />
  </Route>
);
